import _ from "lodash";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Reports from "../../common/reports/Reports";
import Autocomplete from "../../framework/Autocomplete";
import Button from "../../framework/Button";
import GlobalContext from "../../framework/GlobalContext";
import Shortcut from "../../framework/Shortcut";
import classes from "./index.module.css";
import DoctorReportFilter from "./DoctorReportFilter";
import DoctorReportSummary from "./DoctorReportSummary";
import AddDoctor from "./addDoctor";

const Doctors = () => {
  const [showAddDoctor, setShowAddDoctor] = useState(false);
  const [doctorData, setDoctorData] = useState(null);
  const [onFilterShow, setOnFilterShow] = useState(false);
  const [onColumnShow, setOnColumnShow] = useState(false);
  const [rowLevelCTAs, setRowLevelCTAs] = useState([]);
  const [filterStates, setFilterStates] = useState(null);
  const [refreshData, setRefreshData] = useState(false);
  const [filterParams, setFilterParams] = useState(null);
  const [currentRowData, setCurrentRowData] = useState(null);
  const { setCurrentComponent, currentComponent } = useContext(GlobalContext);
  const reportRef = useRef();
  const editRef = useRef();
  const refreshRef = useRef();

  // const refreshData = useCallback((filterData = {}) => {
  //   reportRef.current.applyFilters(filterData);
  // }, []);

  const addDoctor = useCallback((isEdit = false) => {
    if (isEdit) {
      const data = reportRef.current.getCurrentRowData();
      setDoctorData(data);
    }
    setShowAddDoctor(true);
  }, []);

  const closeDoctorAc = useCallback(() => {
    setShowAddDoctor(false);
    setDoctorData(null);
    setCurrentComponent("grid_reports");
  }, [setCurrentComponent]);

  const debouncecloseDoctorAc = _.debounce(closeDoctorAc, 200);

  const listener = useCallback(
    (e) => {
      const key = e.key?.toLowerCase();
      const ctrlKey = e.ctrlKey;
      const altKey = e.altKey;
      if (altKey && key === "r") {
        setRefreshData(true);
        return;
      }
      if (ctrlKey && key === "e") {
        if (currentRowData) return editRef.current.click();
      }
      if (ctrlKey && key === "d") {
        return addDoctor();
      }
    },
    [addDoctor, currentRowData]
  );

  const applyFilterHandler = useCallback((params, filterStates) => {
    setRefreshData(false);
    setFilterParams(params);
    setFilterStates(filterStates);
  }, []);

  useEffect(() => {
    const allRowCTAs = [
      <Button
        ref={editRef}
        startIcon={<Shortcut keys={["Ctrl", "E"]} />}
        label="Edit"
        onClick={() => {
          addDoctor(true);
        }}
        isAccessible={currentRowData}
      />,
    ];
    setRowLevelCTAs(allRowCTAs);
  }, [addDoctor, currentRowData]);

  useEffect(() => {
    if (
      !onFilterShow &&
      !showAddDoctor &&
      !onColumnShow &&
      currentComponent === "grid_reports"
    ) {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [currentComponent, listener, onColumnShow, onFilterShow, showAddDoctor]);
  return (
    <div className={classes["product-report-container"]}>
      <Reports
        identifier="doctor"
        reportRef={reportRef}
        rowLevelCTAs={rowLevelCTAs}
        filterStates={filterStates}
        filterParams={filterParams}
        onFilterShowClick={setOnFilterShow}
        onColumnShowClick={setOnColumnShow}
        filters={
          <DoctorReportFilter
            reportRef={reportRef}
            filters={(filters) => {
              setFilterStates(filters);
            }}
            refreshData={refreshData}
            onFilterShow={onFilterShow}
            applyFilters={applyFilterHandler}
          />
        }
        currentRow={(data) => {
          setCurrentRowData(data);
        }}
      />
      <DoctorReportSummary
        refreshData={() => {
          setRefreshData(true);
        }}
        refreshRef={refreshRef}
        showAutoComplete={() => {
          addDoctor();
        }}
      />
      <Autocomplete
        show={showAddDoctor}
        height="70%"
        width="90%"
        closeAutoComplete={debouncecloseDoctorAc}
      >
        <AddDoctor
          doctorData={doctorData}
          onEscape={debouncecloseDoctorAc}
          onSaveDoctor={() => {
            debouncecloseDoctorAc();
            setRefreshData(true);
          }}
        />
      </Autocomplete>
    </div>
  );
};

export default Doctors;
